import { Callout } from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { RATE_NEGOTIATION_LIST_PATH_FULL } from "@src/appV2/Negotiations/path";
import pluralize from "pluralize";
import { useHistory, useLocation } from "react-router-dom";

interface WorkplaceProposalCalloutProps {
  facilityProposalsCount: number;
}

export function WorkplaceProposalCallout({
  facilityProposalsCount,
}: WorkplaceProposalCalloutProps) {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const useNewRateNegotiationUi = useCbhFlag(CbhFeatureFlag.USE_NEW_RATE_NEGOTIATION_UI, {
    defaultValue: false,
  });

  return (
    <Callout
      title={`${facilityProposalsCount} Workplace ${pluralize("proposal", facilityProposalsCount)}`}
      iconType="coin"
      sx={(theme) => ({
        backgroundColor: theme.palette.intent?.success.background,
        color: theme.palette.intent?.success.text,
      })}
      onClick={() => {
        const params = new URLSearchParams();
        if (searchParams.get("negotiationId")) {
          params.set("negotiationId", searchParams.get("negotiationId")!);
        }

        history.push({
          pathname: useNewRateNegotiationUi
            ? RATE_NEGOTIATION_LIST_PATH_FULL
            : DeprecatedGlobalAppV1Paths.RATE_NEGOTIATIONS,
          search: params.toString(),
        });
      }}
    />
  );
}
